export const telemedicineAssets = {
  telemedicine: {
    benefits: {
      benefit1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/telemedicine_app/benefits/broader-clientele.svg`,
      benefit2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/telemedicine_app/benefits/improved-customer-experience.svg`,
      benefit3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/telemedicine_app/benefits/marketing-opportunities.svg`,
    },
    emerging: {
      emerging1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/telemedicine_app/emerging/5G Low-Latency Video.webp`,
      emerging2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/telemedicine_app/emerging/Ambient Clinical Documentation.webp`,
      emerging3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/telemedicine_app/emerging/Augmented Reality Diagnostics.webp`,
      emerging4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/telemedicine_app/emerging/Blockchain.webp`,
      emerging5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/telemedicine_app/emerging/Digital Therapeutics.webp`,
      emerging6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/telemedicine_app/emerging/Generative AI Agents.webp`,
      emerging7: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/telemedicine_app/emerging/Internet of Medical Things Integration_.webp`,
    },
    solutions: {
      solution1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/telemedicine_app/solutions/appointment-management.svg`,
      solution2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/telemedicine_app/solutions/e-prescribing.svg`,
      solution3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/telemedicine_app/solutions/payment-and-insurance.svg`,
      solution4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/telemedicine_app/solutions/specific-app-development.svg`,
    },
    whyKonstant: {
      why1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/telemedicine_app/why konstant/standards-driven-architecture.svg`,
      why2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/telemedicine_app/why konstant/scalable-system-design.svg`,
      why3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/telemedicine_app/why konstant/device-and-platform-compatibility.svg`,
    },
  },
};
